import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreOrganizationCustomProduct,
} from '../firestore/OrganizationCustomProduct/schema'

export class OrganizationCustomProduct extends ObservableModelWithDecorators<FirestoreOrganizationCustomProduct> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreOrganizationCustomProduct>
  ) {
    super(repository, doc)
  }
}
